module.exports = __webpack_public_path__ + "static/img/login.d22b6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/login.png
// module id = 107
// module chunks = 0